(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6315],{

/***/ 58069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ navigation_header; }
});

// UNUSED EXPORTS: NavigationHeaderForTest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(81361);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/navigation-header/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding: 2rem;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: -3rem;\n  margin-left: -1.5rem;\n  width: calc(100% + 3rem);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: unset;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-51144e95-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var isProductPage = param.isProductPage;
    return isProductPage && "\n      gap: 0.5rem;\n      padding: 0.5rem 2rem 1rem 2rem;\n    ";
});
var LargeDevicePremiumReviewToggleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-51144e95-1"
})(_templateObject1());
var StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-51144e95-2"
})(_templateObject2());
var StyledStrong = (0,styled_components_browser_esm["default"])(ahm_ui/* Strong */.cK).withConfig({
    componentId: "sc-51144e95-3"
})(_templateObject3());
var StyledToggle = (0,styled_components_browser_esm["default"])(ahm_ui/* Toggle */.ZD).withConfig({
    componentId: "sc-51144e95-4"
})(_templateObject4());

// EXTERNAL MODULE: ./src/client/styles/styles.ts
var styles = __webpack_require__(51231);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
;// CONCATENATED MODULE: ./src/client/components/navigation-header/components/navigation-header-title/index.tsx

function navigation_header_title_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    navigation_header_title_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function navigation_header_title_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  padding: 1rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    border-left: 0.5rem solid ",
        ";\n    border-right: 0.5rem solid ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    padding-left: 16.5rem;\n  }\n"
    ]);
    navigation_header_title_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var NavigationHeaderTitle = function(param) {
    var children = param.children, className = param.className, _useHeading = param.useHeading, useHeading = _useHeading === void 0 ? false : _useHeading;
    var TitleElement = useHeading ? ahm_ui.H1 : ahm_ui/* Span */.Dr;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleElement, {
        className: className,
        looksLike: "h5",
        children: children
    });
};
var StyledNavigationHeaderTitle = (0,styled_components_browser_esm["default"])(NavigationHeaderTitle).withConfig({
    componentId: "sc-e9fe7ac9-0"
})(navigation_header_title_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeights.regular;
});
var NavigationUpliftHeaderTitle = (0,styled_components_browser_esm["default"])(StyledNavigationHeaderTitle).withConfig({
    componentId: "sc-e9fe7ac9-1"
})(navigation_header_title_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
/* harmony default export */ var navigation_header_title = (StyledNavigationHeaderTitle);

// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
;// CONCATENATED MODULE: ./src/client/components/navigation-header/components/filter-bar-header/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -17rem;\n  margin-left: -2rem;\n  padding: 18rem 0 0;\n  width: calc(100% + 3rem);\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  max-width: 54rem;\n  padding: 0 1.25rem;\n  text-align: center;\n  @media (min-width: ",
        ") {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin: 0.75rem;\n  @media (min-width: ",
        ") {\n    margin: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    margin-left: 1rem;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: ",
        ") {\n    display: inline;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n  @media (min-width: ",
        ") {\n    align-items: center;\n    display: flex;\n    margin-bottom: 1rem;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  text-align: center;\n  z-index: 999;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 2 / span 4;\n  background-color: ",
        ";\n  margin-top: -0.5rem;\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-top: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var MobileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-db8bbb9d-0"
})(styles_templateObject());
var StyledDisclaimer = (0,styled_components_browser_esm["default"])(price_disclaimer/* default */.ZP).withConfig({
    componentId: "sc-db8bbb9d-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.grey70;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var StyledFindClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-db8bbb9d-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var styles_StyledNavigationHeaderTitle = (0,styled_components_browser_esm["default"])(navigation_header_title).withConfig({
    componentId: "sc-db8bbb9d-3"
})(styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var styles_StyledStrong = (0,styled_components_browser_esm["default"])(ahm_ui/* Strong */.cK).withConfig({
    componentId: "sc-db8bbb9d-4"
})(styles_templateObject4());
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-db8bbb9d-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var FilterBarWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-db8bbb9d-6"
})(_templateObject6(), function(param) {
    var isProductPage = param.isProductPage;
    return isProductPage ? "0rem" : "-0.5rem";
});
var GridColumns = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-db8bbb9d-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-db8bbb9d-8"
})(_templateObject8());

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
;// CONCATENATED MODULE: ./src/client/components/filter-bar/styles.ts

function filter_bar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: ",
        " ",
        ";\n  border-radius: 0.25rem;\n  margin: ",
        " ",
        " 0 ",
        ";\n\n  @media (min-width: ",
        ") {\n    align-items: center;\n    border: none;\n    display: flex;\n    justify-content: center;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    filter_bar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filter_bar_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  & *:nth-last-child(-n + 2) {\n    width: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    & *:last-child {\n      border-right: none;\n    }\n\n    & *:nth-last-child(-n + 2) {\n      width: fit-content;\n    }\n  }\n"
    ]);
    filter_bar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filter_bar_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 0.25rem;\n  box-shadow: 0 0.5rem 1rem 0 rgba(17, 17, 17, 0.04);\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  position: relative;\n  z-index: 999;\n\n  @media (min-width: ",
        ") {\n    border-radius: 3.75rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 0 auto;\n    min-height: 4.5rem;\n  }\n"
    ]);
    filter_bar_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function filter_bar_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  @media (min-width: ",
        ") {\n    margin: 0 auto;\n  }\n"
    ]);
    filter_bar_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function filter_bar_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 2.5rem;\n  margin: ",
        ";\n  white-space: nowrap;\n\n  @media (min-width: ",
        ") {\n    margin: 0.75rem 0.75rem 0.75rem 0;\n    white-space: nowrap;\n  }\n"
    ]);
    filter_bar_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: ",
        " ",
        ";\n  padding-bottom: 0.75rem;\n  padding-left: 1.25rem;\n  padding-top: 0.75rem;\n  text-align: left;\n  white-space: nowrap;\n\n  @media (min-width: ",
        ") {\n    border: none;\n    border-right: ",
        " ",
        ";\n    display: flex;\n    flex-direction: column;\n    font-size: $base-font-size-small;\n    padding: 0 20px;\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var filterBarBorder = "1px solid";
var wrapperMargin = "1rem";
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5448e605-0"
})(filter_bar_styles_templateObject(), filterBarBorder, function(param) {
    var theme = param.theme;
    return theme.colors.grey20;
}, wrapperMargin, wrapperMargin, wrapperMargin, function(param) {
    var theme = param.theme;
    return theme.media.md;
}, wrapperMargin);
var ExtrasComparerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5448e605-1"
})(filter_bar_styles_templateObject1(), function(props) {
    return props.fullWidth ? "100%" : "50%";
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var FlexWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5448e605-2"
})(filter_bar_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var styles_FilterBarWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5448e605-3"
})(filter_bar_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-5448e605-4"
})(filter_bar_styles_templateObject4(), wrapperMargin, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var styles_StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5448e605-5"
})(styles_templateObject5(), filterBarBorder, function(param) {
    var theme = param.theme;
    return theme.colors.grey20;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
}, filterBarBorder, function(param) {
    var theme = param.theme;
    return theme.colors.grey20;
});

// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
// EXTERNAL MODULE: ./src/client/utils/get-is-extras-comparer-page/index.ts
var get_is_extras_comparer_page = __webpack_require__(62833);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/selectors/select-customer-human-readable/index.ts
var select_customer_human_readable = __webpack_require__(34089);
;// CONCATENATED MODULE: ./src/client/components/filter-bar/index.tsx












var FilterBar = function(param) {
    var customer = param.customer, customerReadable = param.customerReadable, needsProductType = param.needsProductType, needsType = param.needsType, openChangeDetailsDrawer = param.openChangeDetailsDrawer;
    var frequency = customer.frequency, hospitalExcess = customer.hospitalExcess, rebate = customer.rebate;
    var ages = customerReadable.ages, incomeTier = customerReadable.incomeTier, scale = customerReadable.scale, state = customerReadable.state;
    var customerAges = (0,fp.flow)(fp.values, (0,fp.join)(" and "))(ages);
    var priceBasedOnSentence = (0,fp.flow)(fp.compact, (0,fp.join)(", "))([
        scale,
        state,
        customerAges
    ]);
    var incomeSentence = rebate ? "".concat(scale, ", ").concat(incomeTier, " per ").concat(ui.PAYMENT_FREQUENCY_LABEL.yearly) : "I don’t want to claim the rebate";
    var isExtrasPage = (0,get_is_extras_comparer_page/* default */.Z)({
        needsProductType: needsProductType,
        needsType: needsType
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_FilterBarWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledDiv, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                    children: "*Price based on"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: (0,fp.upperFirst)(priceBasedOnSentence)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledDiv, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                    children: "Income"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: (0,fp.upperFirst)(incomeSentence)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExtrasComparerWrapper, {
                            fullWidth: isExtrasPage,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledDiv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                            children: "Paying"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: (0,fp.upperFirst)(frequency)
                                        })
                                    ]
                                }),
                                !isExtrasPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledDiv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                            children: "Excess"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                            children: [
                                                "$",
                                                hospitalExcess
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledButton, {
                    icon: {
                        name: "pencil",
                        size: "extraSmall"
                    },
                    onClick: openChangeDetailsDrawer,
                    variant: [
                        "purple"
                    ],
                    children: "Refine Price"
                })
            ]
        })
    });
};
FilterBar.defaultProps = {
    needsProductType: null,
    needsType: null
};
var mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        customerReadable: (0,select_customer_human_readable/* default */.Z)(state)
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    var drawerActions = (0,redux/* bindActionCreators */.DE)(drawer/* default */.Z, dispatch);
    return {
        openChangeDetailsDrawer: function() {
            return drawerActions.openDrawer(ui.DRAWER_IDS.CHANGE_DETAILS);
        }
    };
};
/* harmony default export */ var filter_bar = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(FilterBar));


;// CONCATENATED MODULE: ./src/client/components/navigation-header/components/filter-bar-header/uplifted-header/styles.ts

function uplifted_header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  max-width: 35.625rem;\n  margin: -0.5rem -1rem;\n  text-align: left;\n\n  @media (min-width: ",
        ") {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n\n  @media (min-width: ",
        ") {\n    margin: -1rem -1rem -0.5rem 15rem;\n  }\n"
    ]);
    uplifted_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function uplifted_header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 1.5rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n  }\n"
    ]);
    uplifted_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function uplifted_header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0.75rem 0 0.5rem 0;\n  text-wrap: nowrap;\n\n  @media (min-width: ",
        ") {\n    margin: 0 0 0 1rem;\n  }\n"
    ]);
    uplifted_header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-2b745a9a-0"
})(uplifted_header_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var DisclaimerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2b745a9a-1"
})(uplifted_header_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var uplifted_header_styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-2b745a9a-2"
})(uplifted_header_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});

;// CONCATENATED MODULE: ./src/client/components/navigation-header/components/filter-bar-header/uplifted-header/data.ts


var _obj;
var headerData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, src.CUSTOMER_NEEDS.EXTRAS_COVER, {
    subtitle: "Browse insurance for services like dental, ambulance, optical, and physio.",
    title: "Compare Extras Cover"
}), (0,_define_property/* default */.Z)(_obj, src.CUSTOMER_NEEDS.HOSPITAL_COVER, {
    subtitle: "Browse insurance for in-hospital treatments and find cover to suit your needs.",
    title: "Compare Hospital Cover"
}), (0,_define_property/* default */.Z)(_obj, src.CUSTOMER_NEEDS.PACKAGE_COVER, {
    subtitle: "Explore packages for treatments and services that suit your needs.",
    title: "Hospital and Extras Cover Comparison"
}), _obj);
/* harmony default export */ var data = (headerData);

;// CONCATENATED MODULE: ./src/client/components/navigation-header/components/filter-bar-header/uplifted-header/index.tsx









var UpliftedHeader = function(param) {
    var needsType = param.needsType, products = param.products;
    var dispatch = (0,es/* useDispatch */.I0)();
    var openChangeDetailsDrawer = (0,react.useCallback)(function() {
        drawer/* default.openDrawer */.Z.openDrawer(ui.DRAWER_IDS.CHANGE_DETAILS)(dispatch);
    }, [
        dispatch
    ]);
    var needsData = needsType && (data === null || data === void 0 ? void 0 : data[needsType]);
    if (!needsData) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                looksLike: "h3",
                children: needsData.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                children: needsData.subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(price_disclaimer/* default */.ZP, {
                        elementType: "button",
                        forProducts: products,
                        highlightIncome: true,
                        showRefineLink: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uplifted_header_styles_StyledButton, {
                        variant: [
                            "smallPadding",
                            "border"
                        ],
                        onClick: openChangeDetailsDrawer,
                        children: "Edit details"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var uplifted_header = (UpliftedHeader);

;// CONCATENATED MODULE: ./src/client/components/navigation-header/components/filter-bar-header/index.tsx






var DesktopHeaderFilterBar = function(param) {
    var changeUrl = param.changeUrl, isCombiningHospitalWithExtras = param.isCombiningHospitalWithExtras, isProductListingPage = param.isProductListingPage, isProductListingPageAdd = param.isProductListingPageAdd, isProductListingPageAll = param.isProductListingPageAll, needsProductType = param.needsProductType, needsType = param.needsType, products = param.products, title = param.title, titlePrefix = param.titlePrefix, titleSuffix = param.titleSuffix, useHeading = param.useHeading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBarWrapper, {
        isProductPage: !isProductListingPage && !isProductListingPageAdd,
        children: isProductListingPage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isProductListingPageAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(uplifted_header, {
                    needsType: needsType,
                    products: products
                }),
                !isProductListingPageAll && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledNavigationHeaderTitle, {
                                    useHeading: useHeading,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        "data-testid": "navigation-header-title",
                                        children: [
                                            titlePrefix,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledStrong, {
                                                children: title
                                            }),
                                            " ",
                                            titleSuffix
                                        ]
                                    })
                                }),
                                !isCombiningHospitalWithExtras && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFindClickable, {
                                    to: changeUrl,
                                    children: "Find something else"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_bar, {
                            needsProductType: needsProductType,
                            needsType: needsType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDisclaimer, {
                                elementType: "button",
                                forProducts: products,
                                highlightIncome: true,
                                showRefineLink: false
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GridColumns, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
                lgHorizontalAlign: "center",
                verticalAlign: "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledNavigationHeaderTitle, {
                            useHeading: useHeading,
                            children: [
                                titlePrefix,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledStrong, {
                                    children: title
                                })
                            ]
                        })
                    }),
                    !isCombiningHospitalWithExtras && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            to: changeUrl,
                            variant: "white",
                            children: "Change this"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var filter_bar_header = (DesktopHeaderFilterBar);

// EXTERNAL MODULE: ./src/client/utils/get-title-from-type/index.ts
var get_title_from_type = __webpack_require__(9347);
// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
// EXTERNAL MODULE: ./src/client/components/navigation-header/styles.module.sass
var styles_module = __webpack_require__(85985);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/navigation-header/index.tsx




















var NavigationHeader = function(param) {
    var isCombiningHospitalWithExtras = param.isCombiningHospitalWithExtras, needsProductType = param.needsProductType, needsType = param.needsType, productExtrasType = param.productExtrasType, productQuantity = param.productQuantity, totalProducts = param.totalProducts, products = param.products, productShortName = param.productShortName, productType = param.productType, showPremiumReviewToggle = param.showPremiumReviewToggle, useHeading = param.useHeading, isProductListingPage = param.isProductListingPage, isProductListingPageAll = param.isProductListingPageAll;
    var router = (0,next_router.useRouter)();
    var isProductDetailsChangeThisTestOn = (0,esm/* useFeatureIsOn */.cC)(ui.GROWTHBOOK_PRODUCT_DETAILS_CHANGE_THIS);
    var isChoosableExtra = productExtrasType === src.EXTRAS_TYPE.CHOOSABLE;
    var changeUrl = ahm_constants/* default.URLS.SALES.FIND_HEALTH_INSURANCE */.Z.URLS.SALES.FIND_HEALTH_INSURANCE;
    var isProductListingPageAdd = (0,fp.endsWith)("/add", router.asPath);
    var isProductPage = !(isProductListingPage || isProductListingPageAdd);
    if (isChoosableExtra) {
        changeUrl = ahm_constants/* default.URLS.SALES.CHOOSABLE_PICKER */.Z.URLS.SALES.CHOOSABLE_PICKER;
    }
    var title = isChoosableExtra ? productShortName : (0,get_title_from_type/* default */.Z)({
        needsProductType: needsProductType,
        needsType: needsType,
        productType: productType
    });
    var upliftTitle = "Showing ".concat(totalProducts, " ").concat(title.substring(0, title.lastIndexOf(" ")), " covers");
    var productQuantityText = // @ts-expect-error - Automatic, Please fix when editing this file
    totalProducts && productQuantity < totalProducts ? "".concat(productQuantity, " of ").concat(totalProducts) : productQuantity;
    var titlePrefix = productQuantity ? "".concat(productQuantityText, " options for") : "I’m looking for";
    if (isCombiningHospitalWithExtras) {
        titlePrefix = "Add";
    }
    var titleSuffix = totalProducts && productQuantity && productQuantity < totalProducts ? "based on the below" : "";
    var hideChangeThis = isProductPage && isProductDetailsChangeThisTestOn;
    var renderPremiumReviewToggle = function(isProductListing) {
        var ToggleComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
            type: ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT_WHITE,
            isProductPage: !isProductListing,
            showBackground: false
        });
        if (isProductListing) return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MediaDisplay */.Z, {
            up: true,
            media: ui.MEDIA_SIZE.MD,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeDevicePremiumReviewToggleWrapper, {
                children: ToggleComponent
            })
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MediaDisplay */.Z, {
            media: ui.MEDIA_SIZE.MD,
            children: ToggleComponent
        });
    };
    var renderPremiumReviewToggleUplift = function() {
        var ToggleComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                    xs: true,
                    sm: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                        showBackground: false,
                        type: ui.PREMIUM_REVIEW_TOGGLE_STYLE.INLINE
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                    md: true,
                    df: true,
                    lg: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                        showBackground: false,
                        type: ui.PREMIUM_REVIEW_TOGGLE_STYLE.COMPARER_PAGE
                    })
                })
            ]
        });
        return ToggleComponent;
    };
    var filterBarProps = {
        changeUrl: changeUrl,
        isCombiningHospitalWithExtras: isCombiningHospitalWithExtras,
        isProductListingPage: isProductListingPage,
        isProductListingPageAdd: isProductListingPageAdd,
        isProductListingPageAll: isProductListingPageAll,
        needsProductType: needsProductType,
        needsType: needsType,
        products: products,
        showPremiumReviewToggle: showPremiumReviewToggle,
        title: title,
        titlePrefix: titlePrefix,
        titleSuffix: titleSuffix,
        useHeading: useHeading
    };
    if (hideChangeThis) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                isProductPage: isProductPage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MediaDisplay */.Z, {
                        media: ui.MEDIA_SIZE.MD,
                        up: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_bar_header, (0,_object_spread/* default */.Z)({}, filterBarProps))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MediaDisplay */.Z, {
                        media: ui.MEDIA_SIZE.MD,
                        children: isProductListingPageAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(uplifted_header, {
                            needsType: needsType,
                            products: products
                        }) : // @ts-expect-error - Automatic, Please fix when editing this file
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((styles_module_default()).wrapper, (0,_define_property/* default */.Z)({}, (styles_module_default()).productPage, isProductPage)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).gridWrapper,
                                children: [
                                    isCombiningHospitalWithExtras && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        isUnstyled: true,
                                        icon: {
                                            name: "chevron-left"
                                        },
                                        onClick: router.back,
                                        variant: (styles_module_default()).backButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                                            xs: true,
                                            sm: true,
                                            children: "Back"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((styles_module_default()).gridColumns, (0,_define_property/* default */.Z)({}, (styles_module_default()).productPage, isProductPage)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
                                            lgHorizontalAlign: "center",
                                            verticalAlign: "middle",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                                                    sm: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_header_title, {
                                                        useHeading: useHeading,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            "data-testid": "md-navigation-header-title",
                                                            children: [
                                                                titlePrefix,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStrong, {
                                                                    children: title
                                                                }),
                                                                " ",
                                                                titleSuffix
                                                            ]
                                                        })
                                                    })
                                                }),
                                                !isCombiningHospitalWithExtras && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                                                    sm: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                                        to: changeUrl,
                                                        // @ts-expect-error - Automatic, Please fix when editing this file
                                                        className: classnames_default()((styles_module_default()).button, (0,_define_property/* default */.Z)({}, (styles_module_default()).productPage, isProductPage)),
                                                        variant: "white",
                                                        children: "Change this"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    !isProductListingPageAll && showPremiumReviewToggle && renderPremiumReviewToggle(!isProductPage)
                ]
            }),
            isProductListingPageAll && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationUpliftHeaderTitle, {
                useHeading: useHeading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "data-testid": "md-navigation-header-title",
                        children: upliftTitle
                    }),
                    showPremiumReviewToggle && renderPremiumReviewToggleUplift()
                ]
            })
        ]
    });
};
NavigationHeader.defaultProps = {
    isCombiningHospitalWithExtras: false,
    needsProductType: null,
    needsType: null,
    productExtrasType: null,
    productQuantity: null,
    productShortName: null,
    products: null,
    showPremiumReviewToggle: true,
    totalProducts: null,
    useHeading: false
};

/* harmony default export */ var navigation_header = (NavigationHeader);


/***/ }),

/***/ 46744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ INCLUDES_HOSPITAL; }
/* harmony export */ });
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10453);

var INCLUDES_HOSPITAL = [
    _ahm_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PRODUCT_TYPE.PACKAGE */ .Z.PRODUCT_TYPE.PACKAGE,
    _ahm_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PRODUCT_TYPE.COMBINED */ .Z.PRODUCT_TYPE.COMBINED,
    _ahm_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PRODUCT_TYPE.HOSPITAL */ .Z.PRODUCT_TYPE.HOSPITAL, 
];


/***/ }),

/***/ 1565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_has_hospital_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97279);


var getUnavailableProductProps = function(changeExcessFunction, hospitalExcess, product) {
    var ref, ref1;
    var DEFAULT_EXCESS = "750";
    var RADIX = 10;
    var customerExcess = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.parseInt)(RADIX, hospitalExcess);
    var productExcess = product === null || product === void 0 ? void 0 : (ref = product.charges) === null || ref === void 0 ? void 0 : (ref1 = ref.excess) === null || ref1 === void 0 ? void 0 : ref1.amount;
    var isUnavailableProduct = (0,_utils_has_hospital_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(product) && customerExcess !== productExcess;
    return isUnavailableProduct ? {
        changeExcess: function() {
            return changeExcessFunction(DEFAULT_EXCESS);
        },
        changeTo: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.parseInt)(RADIX, DEFAULT_EXCESS),
        current: customerExcess
    } : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getUnavailableProductProps);


/***/ }),

/***/ 96315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ needs; }
});

// UNUSED EXPORTS: ProductListingPageNeedsForTest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/get-parent-product-id/index.js
var get_parent_product_id = __webpack_require__(36529);
var get_parent_product_id_default = /*#__PURE__*/__webpack_require__.n(get_parent_product_id);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/analytics/google/constants.ts
var constants = __webpack_require__(5331);
// EXTERNAL MODULE: ./src/client/analytics/index.ts + 6 modules
var analytics = __webpack_require__(86039);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/models/url/index.ts
var url = __webpack_require__(26789);
;// CONCATENATED MODULE: ./src/client/pages/product-listing/customise-selected-choosable-product/index.ts


// @ts-expect-error - Automatic, Please fix when editing this file
var customiseSelectedChoosableProduct = function(product, onClick) {
    var selectButton = {
        analyticsLabel: "View ".concat(product === null || product === void 0 ? void 0 : product.name, " cover"),
        text: "View cover",
        to: url/* default.getProductUrl */.Z.getProductUrl(product === null || product === void 0 ? void 0 : product.id),
        variants: [
            "purple"
        ]
    };
    var linkText = "Edit bundles";
    var bottomLink = {
        analyticsLabel: linkText,
        onClick: onClick,
        text: linkText
    };
    return (0,fp.flow)((0,fp.set)("customLabel", "Your customised cover"), (0,fp.set)("selectButton", selectButton), (0,fp.set)("bottomLink", bottomLink))(product);
};
/* harmony default export */ var customise_selected_choosable_product = (customiseSelectedChoosableProduct);

// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
// EXTERNAL MODULE: ./src/client/utils/customer-has-changed/index.ts
var customer_has_changed = __webpack_require__(51552);
// EXTERNAL MODULE: ./src/client/utils/get-future-date/index.tsx
var get_future_date = __webpack_require__(84701);
;// CONCATENATED MODULE: ./src/client/pages/product-listing/components/utils/get-unavailable-products/index.ts

/**
 * Gets the products ids of the products which should be unavailable in the product comparer.
 *
 * @param {object} param - An object.
 * @param {number} param.customerExcess - The excess value on the customer object.
 * @param {Array.string>} param.parentProductIds - Each of the comparer products parent ids.
 * @param {object} param.productIdsWithExcess - Contains keys of each parent id. Each value is the applicable excess.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var getUnavailableProducts = function(param) {
    var customerExcess = param.customerExcess, parentProductIds = param.parentProductIds, productIdsWithExcess = param.productIdsWithExcess;
    return (0,fp.filter)(function(parentId) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        var excessValues = (0,fp.get)(parentId)(productIdsWithExcess);
        return !(0,fp.includes)(customerExcess, excessValues);
    })(parentProductIds);
};
/* harmony default export */ var get_unavailable_products = (getUnavailableProducts);

;// CONCATENATED MODULE: ./src/client/pages/product-listing/components/utils/get-variable-excess-comparer-products/index.ts




var COMBINED_PRODUCT_COMPONENTS = ahm_constants/* default.COMBINED_PRODUCT_COMPONENTS */.Z.COMBINED_PRODUCT_COMPONENTS, PRODUCT_TYPE = ahm_constants/* default.PRODUCT_TYPE */.Z.PRODUCT_TYPE;
var RADIX = 10;
var DEFAULT_EXCESS = 750;
/**
 * Filters the products returned from redux for the variable excess feature.
 *
 * @param {object} param - An object.
 * @param {number} param.customer - The redux customer state, contains the selected excess value.
 * @param {Array.string} param.parentProductIds - Each of the comparer products parent ids.
 * @param {object} param.productIdsWithExcess - Contains keys of each parent id. Each value is the applicable excess.
 * @param {object[]} param.products - Products retrieved from redux for the comparer needs type.
 */ var getVariableExcessComparerProducts = function(param) {
    var customer = param.customer, parentProductIds = param.parentProductIds, productIdsWithExcess = param.productIdsWithExcess, products = param.products;
    var extrasOnlyProducts = (0,fp.every)({
        type: PRODUCT_TYPE.EXTRAS
    })(products);
    if ((0,fp.isEmpty)(productIdsWithExcess) && !extrasOnlyProducts) {
        return [];
    }
    var customerExcess = (0,fp.parseInt)(RADIX, (0,fp.get)("hospitalExcess")(customer));
    var unavailableProductIds = get_unavailable_products({
        customerExcess: customerExcess,
        parentProductIds: parentProductIds,
        productIdsWithExcess: productIdsWithExcess
    });
    return (0,fp.filter)(function(product) {
        var productExcess = (0,fp.get)("charges.excess.amount")(product);
        var parentId = (0,fp.get)("parentProductId")(product);
        var productId = (0,fp.get)("id")(product);
        var softBundleId = get_parent_product_id_default()((0,fp.get)("".concat(productId, ".hospital"))(COMBINED_PRODUCT_COMPONENTS));
        var idToCheckIsAvailable = softBundleId || parentId;
        var excessMatchesCustomer = productExcess === customerExcess;
        var isExtrasProduct = (0,fp.get)("type")(product) === PRODUCT_TYPE.EXTRAS;
        var productIsUnavailable = (0,fp.includes)(idToCheckIsAvailable, unavailableProductIds);
        var showIsUnavailable = productIsUnavailable && productExcess === DEFAULT_EXCESS;
        return excessMatchesCustomer || isExtrasProduct || showIsUnavailable;
    })(products);
};
/* harmony default export */ var get_variable_excess_comparer_products = (getVariableExcessComparerProducts);

;// CONCATENATED MODULE: ./src/client/utils/has-choosable-60-products/index.ts


var hasChoosable60Products = function(products) {
    return (0,fp.some)(function(product) {
        return product.extrasType === src.EXTRAS_TYPE.CHOOSABLE && product.id !== src.PRODUCT.CHOOSABLE_50_TEETH;
    })(products);
};
/* harmony default export */ var has_choosable_60_products = (hasChoosable60Products);

;// CONCATENATED MODULE: ./src/client/pages/product-listing/manufacture-base-choosable-product/images/flexi-limits.svg
/* harmony default export */ var flexi_limits = ({"src":"/_next/static/media/flexi-limits.4b0cff4a.svg","height":200,"width":200});
;// CONCATENATED MODULE: ./src/client/pages/product-listing/manufacture-base-choosable-product/index.ts


// @ts-expect-error - Automatic, Please fix when editing this file
var manufactureBaseChoosableProduct = function(product, onClick) {
    var buttonText = "Select bundles";
    var selectButton = {
        analyticsLabel: buttonText,
        onClick: onClick,
        showButtonTextWhenCondensed: true,
        text: buttonText,
        variants: [
            "border",
            "white"
        ]
    };
    return (0,fp.flow)((0,fp.set)("name", "choosable 60"), (0,fp.set)("content.longForm", [
        "Start with our base bundle of teeth and emergency ambulance, then choose the extras bundles that suit your needs.", 
    ]), (0,fp.set)("customLabel", "Build your own cover"), (0,fp.set)("showFromWithPrice", true), (0,fp.set)("extras.included", []), (0,fp.set)("selectButton", selectButton), (0,fp.set)("columnOverlayContent", {
        extraText: "to unlock inclusions",
        image: {
            alt: "Illustration of inclusion types",
            src: flexi_limits.src
        },
        linkText: "Customise your cover",
        onClick: onClick
    }))(product);
};
/* harmony default export */ var manufacture_base_choosable_product = (manufactureBaseChoosableProduct);

// EXTERNAL MODULE: ./src/client/components/needs-product-data-loader/index.ts + 1 modules
var needs_product_data_loader = __webpack_require__(4035);
// EXTERNAL MODULE: ./src/client/pages/product-listing/product-listing-common.ts
var product_listing_common = __webpack_require__(77484);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/client/utils/get-title-from-type/index.ts
var get_title_from_type = __webpack_require__(9347);
// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
;// CONCATENATED MODULE: ./src/client/pages/product-listing/components/head/index.tsx








// @ts-expect-error - Automatic, Please fix when editing this file
var getTitleForNeeds = function(param) {
    var needsProductType = param.needsProductType, needsType = param.needsType, productType = param.productType;
    return "Health insurance ".concat((0,get_title_from_type/* default */.Z)({
        needsProductType: needsProductType,
        needsType: needsType,
        productType: productType
    }));
};
var DEFAULT_DESCRIPTION = "Compare ahm’s hospital and extras packages. We’ve got your back with a range of private health insurance options and plans to suit your needs.";
var _obj;
var metaDescriptionOverride = (_obj = {}, (0,_define_property/* default */.Z)(_obj, src.CUSTOMER_NEEDS.EXTRAS_COVER, (0,_define_property/* default */.Z)({}, src.CUSTOMER_NEEDS.ALL, {
    description: "Compare extras insurance cover options for services like dental, physio, optical & ambulance, plus more! View the full range here. Buy online today.",
    titleSuffix: "Extras only"
})), (0,_define_property/* default */.Z)(_obj, src.CUSTOMER_NEEDS.HOSPITAL_COVER, (0,_define_property/* default */.Z)({}, src.CUSTOMER_NEEDS.ALL, {
    description: "Compare hospital cover options, find the best hospital cover for you. Options and control in case of in-hospital treatments, including elective surgeries and medical surgeries.",
    titleSuffix: "Hospital only"
})), _obj);
var ProductListingHead = function(param) {
    var needsProductType = param.needsProductType, needsType = param.needsType, productType = param.productType;
    var metaDescription = (0,fp.getOr)(DEFAULT_DESCRIPTION, "".concat(needsType, ".").concat(needsProductType, ".description"))(metaDescriptionOverride);
    var needsTitle = getTitleForNeeds({
        needsProductType: needsProductType,
        needsType: needsType,
        productType: productType
    });
    // @ts-expect-error - Automatic, Please fix when editing this file
    var titleSuffix = (0,fp.getOr)("", "".concat(needsType, ".").concat(needsProductType, ".titleSuffix"))(metaDescriptionOverride);
    var metaTitle = titleSuffix ? "".concat(needsTitle, " plans & ").concat(titleSuffix) : needsTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
        titleTemplate: ui.SHORT_PAGE_TITLE_TEMPLATE,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            })
        ]
    });
};
ProductListingHead.defaultProps = {
    needsProductType: ""
};
/* harmony default export */ var components_head = (ProductListingHead);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/routes/utils/get-product-routes/index.ts
var get_product_routes = __webpack_require__(25155);
// EXTERNAL MODULE: ./src/client/components/pricing-modal/constants/index.ts
var pricing_modal_constants = __webpack_require__(46744);
// EXTERNAL MODULE: ./src/client/styles/styles.ts
var styles = __webpack_require__(51231);
// EXTERNAL MODULE: ./src/client/components/offers/tile/constants/index.ts
var tile_constants = __webpack_require__(77388);
// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
// EXTERNAL MODULE: ./src/client/utils/has-hospital-component/index.ts
var has_hospital_component = __webpack_require__(97279);
;// CONCATENATED MODULE: ./src/client/elements/product-panels/utils/get-is-product-unavailable/index.ts


// @ts-expect-error - Automatic, Please fix when editing this file
var getIsProductUnavailable = function(param) {
    var product = param.product, customerExcess = param.customerExcess;
    var productExcess = (0,fp.get)("charges.excess.amount")(product);
    return (0,has_hospital_component/* default */.Z)(product) && customerExcess !== productExcess;
};
/* harmony default export */ var get_is_product_unavailable = (getIsProductUnavailable);

;// CONCATENATED MODULE: ./src/client/elements/product-panels/utils/get-closest-available-product-index/index.ts


// @ts-expect-error - Automatic, Please fix when editing this file
var reduceWithIndex = fp.reduce.convert({
    cap: false
});
var INITIAL_VALUE = 0;
// @ts-expect-error - Automatic, Please fix when editing this file
var getNextAvailable = function(param) {
    var products = param.products, customerExcess = param.customerExcess, currentIndex = param.currentIndex;
    return reduceWithIndex(// @ts-expect-error - Automatic, Please fix when editing this file
    function(currentClosest, product, productIndex) {
        var isProductUnavailable = get_is_product_unavailable({
            customerExcess: customerExcess,
            product: product
        });
        if (isProductUnavailable) {
            return currentClosest;
        }
        // checks if the current product in the loop is closer than the current closest product id
        var comparison = Math.abs(productIndex - (currentIndex + 1)) < Math.abs(currentClosest - (currentIndex + 1));
        return comparison ? productIndex : currentClosest;
    }, INITIAL_VALUE, products);
};
/**
 * Returns the index of the closest available product in the product comparer, so the user always sees an available product first.
 *
 * @param {object} param - An object.
 * @param {number} param.customerExcess - The current selected excess from the redux customer state.
 * @param {object[]} param.products - Products retrieved from redux for the comparer needs type.
 * @param {number} param.currentIndex - The current index position the comparer is set to.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var getAvailableProductIndex = function(param) {
    var currentIndex = param.currentIndex, customerExcess = param.customerExcess, products = param.products;
    var focusedProduct = products[currentIndex];
    var isFocusedProductUnavailable = get_is_product_unavailable({
        customerExcess: customerExcess,
        product: focusedProduct
    });
    return isFocusedProductUnavailable ? getNextAvailable({
        currentIndex: currentIndex,
        customerExcess: customerExcess,
        products: products
    }) : currentIndex;
};
/* harmony default export */ var get_closest_available_product_index = (getAvailableProductIndex);

// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var models_product = __webpack_require__(43735);
;// CONCATENATED MODULE: ./src/client/utils/get-combined-product-url/index.ts




// @ts-expect-error - Automatic, Please fix when editing this file
var getCombinedProductUrl = function(param) {
    var cartProduct = param.cartProduct, chosenProduct = param.chosenProduct;
    var productsArray = (0,fp.keyBy)(function(product) {
        return product.type;
    })([
        cartProduct,
        chosenProduct
    ]);
    var combinedCartProduct = models_product/* default.getCombinedCartObject */.Z.getCombinedCartObject((0,_object_spread/* default */.Z)({}, productsArray));
    var combinedProductId = (0,fp.get)("id")(combinedCartProduct);
    return url/* default.getProductUrl */.Z.getProductUrl(combinedProductId);
};
/* harmony default export */ var get_combined_product_url = (getCombinedProductUrl);

// EXTERNAL MODULE: ./src/client/utils/get-is-extras-comparer-page/index.ts
var get_is_extras_comparer_page = __webpack_require__(62833);
// EXTERNAL MODULE: ./src/client/pages/build-your-cover/utils/get-unavailable-product-props/index.ts
var get_unavailable_product_props = __webpack_require__(1565);
;// CONCATENATED MODULE: ./src/client/utils/has-choosable-products/index.ts


var hasChoosableProducts = function(products) {
    return (0,fp.some)({
        extrasType: src.EXTRAS_TYPE.CHOOSABLE
    })(products);
};
/* harmony default export */ var has_choosable_products = (hasChoosableProducts);

// EXTERNAL MODULE: ./src/client/utils/is-product-best-seller/index.ts
var is_product_best_seller = __webpack_require__(591);
// EXTERNAL MODULE: ./src/client/components/loading-spinner/index.tsx
var loading_spinner = __webpack_require__(30950);
// EXTERNAL MODULE: ./src/client/actions/modal/index.ts
var modal = __webpack_require__(18826);
// EXTERNAL MODULE: ./src/client/components/navigation-header/index.tsx + 9 modules
var navigation_header = __webpack_require__(58069);
// EXTERNAL MODULE: ./src/client/components/offers/banner/index.tsx + 2 modules
var banner = __webpack_require__(9010);
// EXTERNAL MODULE: ./src/client/components/offers/tile/index.tsx + 10 modules
var tile = __webpack_require__(24329);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/utils/bundle/index.ts
var bundle = __webpack_require__(57107);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/ambulance-section/index.tsx + 2 modules
var ambulance_section = __webpack_require__(53138);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/base-bundle-section/index.tsx + 1 modules
var base_bundle_section = __webpack_require__(23996);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/index.tsx + 3 modules
var bundles_section = __webpack_require__(2058);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/components/bundle-chosen-view/index.tsx
var bundle_chosen_view = __webpack_require__(98985);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/components/disclaimer/index.tsx
var disclaimer = __webpack_require__(20074);
// EXTERNAL MODULE: ./src/client/utils/scroll-to-element-with-id/index.ts
var scroll_to_element_with_id = __webpack_require__(11402);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/components/no-bundle-chosen-view/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  text-align: right;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media (min-width: ",
        ") {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-37fe6b8-0"
})(_templateObject());
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-37fe6b8-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var isCondensed = param.isCondensed;
    return isCondensed ? "100%" : "auto";
});
var NoBundleChosenView = function(param) {
    var _isCondensed = param.isCondensed, isCondensed = _isCondensed === void 0 ? false : _isCondensed;
    var handleButtonClick = (0,react.useCallback)(function() {
        (0,scroll_to_element_with_id/* default */.Z)("bundles-section");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclaimer/* default */.Z, {
                showRefineLink: !isCondensed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    isCondensed: isCondensed,
                    variant: (0,fp.compact)([
                        "border",
                        "white",
                        isCondensed && "marginBottomSpacer11"
                    ]),
                    onClick: handleButtonClick,
                    children: "Choose bundles"
                })
            })
        ]
    });
};
/* harmony default export */ var no_bundle_chosen_view = (NoBundleChosenView);

;// CONCATENATED MODULE: ./src/client/components/picker-drawer/components/footer/index.tsx

function footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n"
    ]);
    footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var FooterWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4dad2bf0-0"
})(footer_templateObject());
var Footer = function(param) {
    var customer = param.customer, effectiveDate = param.effectiveDate, prices = param.prices, selectedBundles = param.selectedBundles;
    var isBundleChosen = (0,fp.size)(selectedBundles) > 0;
    var productId = (0,bundle/* determineProductIdFromBundles */.F)(selectedBundles);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
        children: isBundleChosen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bundle_chosen_view/* default */.Z, {
            customer: customer,
            effectiveDate: effectiveDate,
            isCondensed: true,
            prices: prices,
            productId: productId
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(no_bundle_chosen_view, {
            isCondensed: true
        })
    });
};
Footer.defaultProps = {
    effectiveDate: null,
    prices: null
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/utils/get-choosable-all-included-services/index.ts
var get_choosable_all_included_services = __webpack_require__(5684);
// EXTERNAL MODULE: ./src/client/selectors/select-choosable-comparer-product-id/index.ts
var select_choosable_comparer_product_id = __webpack_require__(13545);
// EXTERNAL MODULE: ./src/client/selectors/select-current-drawer/index.ts
var select_current_drawer = __webpack_require__(84466);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/selectors/select-effective-date-override/index.ts
var select_effective_date_override = __webpack_require__(89298);
// EXTERNAL MODULE: ./src/client/selectors/select-is-premium-change-enabled/index.ts
var select_is_premium_change_enabled = __webpack_require__(45424);
// EXTERNAL MODULE: ./src/client/selectors/select-products/index.ts
var select_products = __webpack_require__(2664);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/snake-separator/index.tsx + 1 modules
var snake_separator = __webpack_require__(82024);
;// CONCATENATED MODULE: ./src/client/components/picker-drawer/index.tsx





















var PickerDrawer = function(param) {
    var actions = param.actions, choosableComparerProductId = param.choosableComparerProductId, customer = param.customer, drawer = param.drawer, effectiveDate = param.effectiveDate, prices = param.prices, products = param.products;
    var ref = (0,react.useState)([]), selectedBundles = ref[0], setSelectedBundles = ref[1];
    var isOpen = drawer === ui.DRAWER_IDS.PICKER;
    var allIncludedServices = (0,get_choosable_all_included_services/* default */.Z)(products);
    var teethBundleServices = allIncludedServices.find(function(bundle) {
        return bundle.limitId === src.PRODUCT_LIMIT_CATEGORY.TEETH;
    });
    (0,react.useEffect)(function() {
        // @ts-expect-error - Automatic, Please fix when editing this file
        setSelectedBundles((0,bundle/* determineBundlesFromProductId */.M)(choosableComparerProductId));
    }, [
        choosableComparerProductId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Drawer */.dy, {
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {
            customer: customer,
            effectiveDate: effectiveDate,
            prices: prices,
            selectedBundles: selectedBundles
        }),
        isFullWidthMobile: true,
        isOpen: isOpen,
        isWide: true,
        location: "right",
        shouldReturnFocusAfterClose: false,
        title: "Choosable extras",
        toggleMenu: actions.drawer.closeDrawer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_bundle_section/* default */.Z, {
                includedServices: teethBundleServices,
                isBundleChosen: true,
                scale: customer.scale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ambulance_section/* default */.Z, {
                isStacked: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snake_separator/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bundles_section/* default */.Z, {
                allIncludedServices: allIncludedServices,
                isCondensed: true,
                scale: customer.scale,
                selectedBundles: selectedBundles,
                setSelectedBundles: setSelectedBundles
            })
        ]
    });
};
PickerDrawer.defaultProps = {
    choosableComparerProductId: null,
    drawer: null,
    effectiveDate: null,
    prices: null,
    products: null
};
var mapStateToProps = function(state) {
    return {
        // @ts-expect-error - Automatic, Please fix when editing this file
        choosableComparerProductId: (0,select_choosable_comparer_product_id/* default */.Z)(state),
        customer: (0,select_customer/* default */.Z)(state),
        drawer: (0,select_current_drawer/* default */.Z)(state),
        effectiveDate: (0,select_effective_date_override/* default */.Z)(state),
        isPremiumChangeEnabled: (0,select_is_premium_change_enabled/* default */.Z)(state),
        prices: state.price.data,
        products: (0,select_products/* default */.Z)(state),
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            drawer: (0,redux/* bindActionCreators */.DE)(drawer/* default */.Z, dispatch)
        }
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
/* harmony default export */ var picker_drawer = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PickerDrawer));

// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/index.tsx + 7 modules
var pricing_drawer = __webpack_require__(87022);
// EXTERNAL MODULE: ./src/client/actions/action-types.ts
var action_types = __webpack_require__(23094);
;// CONCATENATED MODULE: ./src/client/actions/product-comparer/index.ts

// @ts-expect-error - Automatic, Please fix when editing this file
var reviewDirectComparisonProductIds = function(comparerProducts, productType) {
    return {
        comparerProducts: comparerProducts,
        productType: productType,
        type: action_types/* PRODUCT_COMPARER_DIRECT_COMPARISON_PRODUCT_CHANGE */.bM
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var storeActiveIndex = function(activeIndex, productComparisonId) {
    return {
        activeIndex: activeIndex,
        productComparisonId: productComparisonId,
        type: action_types/* PRODUCT_COMPARER_ACTIVE_INDEX */.Ib
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var toggleDirectComparisonProductId = function(productId, productType) {
    return {
        productId: productId,
        productType: productType,
        type: action_types/* PRODUCT_COMPARER_DIRECT_COMPARISON_TOGGLE */.dn
    };
};
/* harmony default export */ var product_comparer = ({
    reviewDirectComparisonProductIds: reviewDirectComparisonProductIds,
    storeActiveIndex: storeActiveIndex,
    toggleDirectComparisonProductId: toggleDirectComparisonProductId
});

// EXTERNAL MODULE: ./src/client/selectors/select-cart/index.ts
var select_cart = __webpack_require__(1767);
// EXTERNAL MODULE: ./src/client/selectors/select-has-partner-referrer/index.ts
var select_has_partner_referrer = __webpack_require__(93830);
// EXTERNAL MODULE: ./src/client/selectors/select-target-segment/index.ts
var select_target_segment = __webpack_require__(80622);
// EXTERNAL MODULE: ./src/client/elements/product-panels/styles.module.sass
var styles_module = __webpack_require__(83477);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/elements/product-panels/index.tsx



function product_panels_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% + 2rem);\n  margin-left: -1rem;\n  margin-bottom: -2rem;\n  margin-top: 2rem;\n"
    ]);
    product_panels_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_panels_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    border-left: 0.5rem solid ",
        ";\n    border-right: 0.5rem solid ",
        ";\n  }\n"
    ]);
    product_panels_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









































var StyledDisclaimerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4f0aac1e-0"
})(product_panels_templateObject());
var OfferBannerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4f0aac1e-1"
})(product_panels_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var _URLS = ahm_constants/* default.URLS */.Z.URLS, CHOOSABLE_PICKER = _URLS.SALES.CHOOSABLE_PICKER;
// @ts-expect-error - Automatic, Please fix when editing this file
var getNeedsBasedProductLimit = function(needsType, needsProductType) {
    if (needsType === src.CUSTOMER_NEEDS.TAX && needsProductType === src.NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL) {
        return 3;
    }
    return null;
};
var product_panels_RADIX = 10;
var productMapperFactory = function(param) {
    var // @ts-expect-error - Automatic, Please fix when editing this file
    cartProduct = param.cartProduct, // @ts-expect-error - Automatic, Please fix when editing this file
    customer = param.customer, // @ts-expect-error - Automatic, Please fix when editing this file
    customerActions = param.customerActions, // @ts-expect-error - Automatic, Please fix when editing this file
    frequency = param.frequency, // @ts-expect-error - Automatic, Please fix when editing this file
    isCombiningHospitalWithExtras = param.isCombiningHospitalWithExtras, // @ts-expect-error - Automatic, Please fix when editing this file
    prices = param.prices, // @ts-expect-error - Automatic, Please fix when editing this file
    scale = param.scale, // @ts-expect-error - Automatic, Please fix when editing this file
    showBestSellerLabel = param.showBestSellerLabel, // @ts-expect-error - Automatic, Please fix when editing this file
    state = param.state, // @ts-expect-error - Automatic, Please fix when editing this file
    useFutureEffectiveDate = param.useFutureEffectiveDate;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(product) {
        var isAvailable = models_product/* default.isAvailableIn */.Z.isAvailableIn(product, state) && models_product/* default.isAvailableFor */.Z.isAvailableFor(product, scale);
        if (!isAvailable) {
            return null;
        }
        var productId = product.id, productName = product.name, parentProductId = product.parentProductId, selectButton = product.selectButton, productType = product.type;
        var date = (0,get_future_date/* default */.Z)(useFutureEffectiveDate);
        var price = isAvailable ? models_price/* default.getPrice */.Z.getPrice(prices, productId, customer, {
            date: date
        }) : undefined;
        var priceObject = price ? models_price/* default.getAmountAsObject */.Z.getAmountAsObject(price, frequency) : undefined;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
            isAvailable: isAvailable,
            isBestSeller: showBestSellerLabel && (0,is_product_best_seller/* default */.Z)({
                parentProductId: parentProductId,
                productId: productId,
                productType: productType,
                scale: scale
            }),
            price: priceObject,
            scale: scale,
            selectButton: selectButton || {
                analyticsLabel: "View ".concat(productName, " cover"),
                text: "".concat(isCombiningHospitalWithExtras ? "Add" : "View", " cover"),
                to: isCombiningHospitalWithExtras ? get_combined_product_url({
                    cartProduct: cartProduct,
                    chosenProduct: product
                }) : url/* default.getProductUrl */.Z.getProductUrl(productId)
            },
            unavailableWithExcessInfo: (0,get_unavailable_product_props/* default */.Z)(customerActions.changeHospitalExcess, customer.hospitalExcess, product)
        });
    });
};
var ProductPanels = function(param) {
    var actions = param.actions, activeIndex = param.activeIndex, cart = param.cart, comparerProducts = param.comparerProducts, customer = param.customer, isCombiningHospitalWithExtras = param.isCombiningHospitalWithExtras, isPartnerReferral = param.isPartnerReferral, isRankSorted = param.isRankSorted, match = param.match, needsProductType = param.needsProductType, needsType = param.needsType, prices = param.prices, productComparisonId = param.productComparisonId, productIdsWithExcess = param.productIdsWithExcess, productType = param.productType, selectedComparisonProductIds = param.selectedComparisonProductIds, showBestSellerLabel = param.showBestSellerLabel, targetSegment = param.targetSegment, useFutureEffectiveDate = param.useFutureEffectiveDate;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isComparisonDrawerOpen = ref[0], setIsComparisonDrawerOpen = ref[1];
    var onGoToIndex = (0,fp.throttle)(100, function(index) {
        return actions.productComparer.storeActiveIndex(index, productComparisonId);
    });
    var cartProduct = (0,fp.get)("product")(cart);
    var comparerProductsType = (0,fp.get)("type", (0,fp.head)(comparerProducts));
    // @ts-expect-error - Automatic, Please fix when editing this file
    var selectedComparisonProductIdsForType = selectedComparisonProductIds[comparerProductsType];
    // @ts-expect-error - Automatic, Please fix when editing this file
    var toggleComparisonSelections = function(productId) {
        if ((0,fp.includes)(productId, selectedComparisonProductIdsForType)) {
            setIsComparisonDrawerOpen(false);
        } else {
            setIsComparisonDrawerOpen((0,fp.size)(selectedComparisonProductIdsForType) === 1);
        }
        actions.productComparer.toggleDirectComparisonProductId(productId, comparerProductsType);
    };
    var toggleComparisonDrawer = function() {
        setIsComparisonDrawerOpen(!isComparisonDrawerOpen);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    var frequency = customer.frequency, scale = customer.scale, state = customer.state;
    var mappedProducts = (0,react.useMemo)(function() {
        var sortedProducts = isRankSorted ? (0,fp.sortBy)("rank", comparerProducts) : comparerProducts;
        return (0,fp.flow)((0,fp.map)(productMapperFactory({
            cartProduct: cartProduct,
            customer: customer,
            customerActions: (0,fp.get)("customer")(actions),
            frequency: frequency,
            isCombiningHospitalWithExtras: isCombiningHospitalWithExtras,
            prices: prices,
            scale: scale,
            showBestSellerLabel: showBestSellerLabel,
            state: state,
            useFutureEffectiveDate: useFutureEffectiveDate
        })), fp.compact)(sortedProducts);
    }, [
        cartProduct,
        customer,
        actions,
        frequency,
        isCombiningHospitalWithExtras,
        prices,
        scale,
        showBestSellerLabel,
        state,
        useFutureEffectiveDate,
        comparerProducts,
        isRankSorted, 
    ]);
    var needsBasedProductLimit = getNeedsBasedProductLimit(needsType, needsProductType);
    var products = needsBasedProductLimit ? (0,fp.take)(needsBasedProductLimit, mappedProducts) : mappedProducts;
    var productsLoaded = !(0,fp.isEmpty)(products);
    (0,react.useEffect)(function() {
        actions.productComparer.reviewDirectComparisonProductIds(mappedProducts, comparerProductsType);
    }, [
        cartProduct,
        comparerProducts
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        if ((0,fp.size)(products)) {
            var currentIndex = !(0,fp.isNull)(activeIndex) ? activeIndex : 0;
            var customerExcess = (0,fp.parseInt)(product_panels_RADIX, (0,fp.get)("hospitalExcess")(customer));
            // Reset index back to 0 when toggling between recommended products
            var goToIndex = get_closest_available_product_index({
                currentIndex: currentIndex,
                customerExcess: customerExcess,
                products: products
            });
            onGoToIndex(goToIndex);
        }
    }, [
        products
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var isProductWithHospitalServices = (0,fp.some)(function(product) {
        return (0,fp.includes)(product.type, pricing_modal_constants/* INCLUDES_HOSPITAL */.G);
    }, products);
    var isProductIdsWithExcessLoaded = !isProductWithHospitalServices || !(0,fp.isEmpty)(productIdsWithExcess) || (0,fp.isNull)(productIdsWithExcess);
    // This prevents them from finishing loading at different times, causing the loading component to flicker.
    var isLoadingVariableExcess = !(productsLoaded && isProductIdsWithExcessLoaded);
    if (isLoadingVariableExcess || (0,fp.isEmpty)(products)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
    }
    var isApplicableForExtrasBanner = !has_choosable_60_products(products) && (0,get_is_extras_comparer_page/* default */.Z)({
        needsProductType: needsProductType,
        needsType: needsType
    });
    var choosableBannerProps = isApplicableForExtrasBanner ? {
        link: {
            text: has_choosable_products(products) ? "View more choosable extras" : "View choosable extras",
            to: CHOOSABLE_PICKER
        }
    } : null;
    var isProductListingPage = (0,fp.includes)(router.asPath, (0,get_product_routes/* getProductListingUrlsByNeeds */.D3)());
    var isProductListingPageAll = isProductListingPage && (0,fp.endsWith)("/all", router.asPath);
    var priceDisclaimerProps = {
        bold: true,
        elementType: "button",
        forProducts: products,
        highlightIncome: true,
        showRefineLink: true
    };
    var priceDisclaimer = !isProductListingPageAll && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(price_disclaimer/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, priceDisclaimerProps), {
                hideForDesktop: isProductListingPage
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* MediaDisplay */.Z, {
                media: ui.MEDIA_SIZE.MD,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDisclaimerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                        type: ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT_WHITE,
                        showBackground: false
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isPartnerReferral && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBannerWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                    filterProductId: (0,fp.get)("id", (0,fp.head)(products)),
                    targetSegment: targetSegment
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_header/* default */.Z, {
                isCombiningHospitalWithExtras: isCombiningHospitalWithExtras,
                productQuantity: (0,fp.size)(products),
                productType: productType,
                totalProducts: comparerProducts.length,
                needsProductType: needsProductType,
                needsType: needsType,
                useHeading: true,
                products: products,
                isProductListingPage: isProductListingPage,
                isProductListingPageAll: isProductListingPageAll
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ProductComparer */.fz, {
                activeIndex: activeIndex,
                choosableBanner: choosableBannerProps,
                disclaimer: priceDisclaimer,
                limitWidth: true,
                onGoToIndex: onGoToIndex,
                // @ts-expect-error - Automatic, Please fix when editing this file
                paymentFrequency: customer.frequency,
                products: products,
                selectedComparisonProductIds: selectedComparisonProductIdsForType,
                toggleComparisonDrawer: toggleComparisonDrawer,
                toggleComparisonSelections: toggleComparisonSelections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_drawer/* default */.Z, {
                useFutureEffectiveDate: useFutureEffectiveDate,
                isProductWithHospitalServices: isProductWithHospitalServices,
                // @ts-expect-error - Automatic, Please fix when editing this file
                match: match
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(picker_drawer, {}),
            !isPartnerReferral && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).offerTile,
                "data-testid": "offer-tile-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tile/* default */.Z, {
                    filterProductId: (0,fp.get)("id", (0,fp.head)(products)),
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    targetSegment: targetSegment,
                    variant: tile_constants/* VARIANT.STRIP */.c.STRIP
                })
            })
        ]
    });
};
ProductPanels.defaultProps = {
    activeIndex: 0,
    cart: null,
    isCombiningHospitalWithExtras: false,
    isRankSorted: true,
    needsProductType: null,
    needsType: null,
    pageHistory: null,
    productIdsWithExcess: null,
    showBestSellerLabel: false
};
var product_panels_mapStateToProps = function(state) {
    // Note: pathname will be undefined when server-side rendering
    var pathname = (0,fp.get)("router.location.pathname", state);
    var productComparisonId = (0,fp.replace)("/health-insurance/", "", pathname);
    return {
        activeIndex: (0,fp.getOr)(null, "productComparer.activeIndices.".concat(productComparisonId), state),
        cart: (0,select_cart/* default */.Z)(state),
        isPartnerReferral: (0,select_has_partner_referrer/* default */.Z)(state),
        pageHistory: (0,fp.getOr)(null, "history[1]", state),
        productComparisonId: productComparisonId,
        selectedComparisonProductIds: (0,fp.get)("productComparer.directComparisonProductIds", state),
        showBestSellerLabel: (0,fp.some)(function(productListingUrl) {
            return productListingUrl === pathname;
        }, [
            ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_EXTRAS */.Z.URLS.SALES.PRODUCT_LISTING_EXTRAS,
            ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_EXTRAS_ADD */.Z.URLS.SALES.PRODUCT_LISTING_EXTRAS_ADD,
            ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_HOSPITAL */.Z.URLS.SALES.PRODUCT_LISTING_HOSPITAL,
            ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_HOSPITAL_ADD */.Z.URLS.SALES.PRODUCT_LISTING_HOSPITAL_ADD,
            ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_PACKAGES */.Z.URLS.SALES.PRODUCT_LISTING_PACKAGES, 
        ]),
        targetSegment: (0,select_target_segment/* default */.Z)(state),
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var product_panels_mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            modal: (0,redux/* bindActionCreators */.DE)(modal/* default */.Z, dispatch),
            productComparer: (0,redux/* bindActionCreators */.DE)(product_comparer, dispatch)
        }
    };
};
/* harmony default export */ var product_panels = ((0,es/* connect */.$j)(product_panels_mapStateToProps, product_panels_mapDispatchToProps)(ProductPanels));


// EXTERNAL MODULE: ./src/client/selectors/select-filtered-needs-products-by-customer/index.ts
var select_filtered_needs_products_by_customer = __webpack_require__(2382);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(22222);
// EXTERNAL MODULE: ./src/client/selectors/select-location/index.ts
var select_location = __webpack_require__(88176);
;// CONCATENATED MODULE: ./src/client/selectors/select-is-combining-hospital-with-extras/index.ts





var select_is_combining_hospital_with_extras_PRODUCT_TYPE = ahm_constants/* default.PRODUCT_TYPE */.Z.PRODUCT_TYPE, SALES = ahm_constants/* default.URLS.SALES */.Z.URLS.SALES;
// @ts-expect-error - Automatic, Please fix when editing this file
var isCombiningHospitalWithExtras = function(cart, pathname) {
    var hasExtrasInCart = (0,fp.get)("baseProductType")(cart) === select_is_combining_hospital_with_extras_PRODUCT_TYPE.EXTRAS;
    var hasHospitalInCart = (0,fp.get)("baseProductType")(cart) === select_is_combining_hospital_with_extras_PRODUCT_TYPE.HOSPITAL;
    var hasCombinedProductInCart = (0,fp.get)("product.type")(cart) === select_is_combining_hospital_with_extras_PRODUCT_TYPE.COMBINED;
    var isCombiningHospital = pathname === "".concat(SALES.PRODUCT_LISTING_HOSPITAL, "/add") && hasExtrasInCart;
    var isCombiningExtras = pathname === "".concat(SALES.PRODUCT_LISTING_EXTRAS, "/add") && hasHospitalInCart;
    return (isCombiningHospital || isCombiningExtras) && !hasCombinedProductInCart;
};
var selectIsCombiningHospitalWithExtras = (0,reselect_es.createSelector)([
    select_cart/* default */.Z,
    select_location/* default */.Z
], isCombiningHospitalWithExtras);
/* harmony default export */ var select_is_combining_hospital_with_extras = (selectIsCombiningHospitalWithExtras);

// EXTERNAL MODULE: ./src/client/selectors/select-needs-product-type/index.ts
var select_needs_product_type = __webpack_require__(82488);
// EXTERNAL MODULE: ./src/client/selectors/select-needs-type/index.ts
var select_needs_type = __webpack_require__(69286);
// EXTERNAL MODULE: ./src/client/pages/product-listing/styles.module.sass
var product_listing_styles_module = __webpack_require__(83033);
var product_listing_styles_module_default = /*#__PURE__*/__webpack_require__.n(product_listing_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/product-listing/needs.tsx
































var needs_COMBINED_PRODUCT_COMPONENTS = ahm_constants/* default.COMBINED_PRODUCT_COMPONENTS */.Z.COMBINED_PRODUCT_COMPONENTS;
var getParentProductIds = function(param) {
    var products = param.products;
    return (0,fp.flow)([
        (0,fp.map)(function(product) {
            var ref;
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'id' does not exist on type '{}'.
            var productId = product === null || product === void 0 ? void 0 : product.id;
            var softBundleHospitalId = needs_COMBINED_PRODUCT_COMPONENTS === null || needs_COMBINED_PRODUCT_COMPONENTS === void 0 ? void 0 : (ref = needs_COMBINED_PRODUCT_COMPONENTS[productId]) === null || ref === void 0 ? void 0 : ref.hospital;
            var idToGetParent = softBundleHospitalId || productId;
            return get_parent_product_id_default()(idToGetParent);
        }),
        fp.uniq,
        fp.compact, 
    ])(products);
};
var getProductsWithoutChoosable60 = function(comparerProducts) {
    return (0,fp.reject)(function(product) {
        return (0,fp.includes)(product.id, ui.CHOOSABLE_PRODUCTS) && product.id !== src.PRODUCT.CHOOSABLE_50_TEETH;
    }, comparerProducts);
};
var ProductListingPageNeeds = function(param) {
    var actions = param.actions, choosableComparerProductId = param.choosableComparerProductId, customer = param.customer, isCombiningHospitalWithExtras = param.isCombiningHospitalWithExtras, match = param.match, needsProductType = param.needsProductType, needsType = param.needsType, prices = param.prices, productIdsWithExcess = param.productIdsWithExcess, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        // Previously, the cart used to be cleared on mount of this component allowing the customer
        // to add a new hospital product. Now, if the customer has already been to an extras product
        // page and have an extras product in their cart, we want the extras product to remain in
        // the cart and allow the customer to bundle a hospital product with their chosen extras
        // product.
        if (!isCombiningHospitalWithExtras) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            actions.cart.clearCart();
        }
    // @ts-expect-error - Automatic, Please fix when editing this file
    }, [
        actions.cart,
        isCombiningHospitalWithExtras
    ]);
    var parentProductIds = getParentProductIds({
        products: products
    });
    var comparerProducts = get_variable_excess_comparer_products({
        customer: customer,
        parentProductIds: parentProductIds,
        productIdsWithExcess: productIdsWithExcess,
        products: products
    });
    var customerHasChanged = (0,customer_has_changed/* default */.Z)(customer, useFutureEffectiveDate);
    var productIds = (0,fp.map)("id", comparerProducts);
    var productIdsHaveChanged = (0,fp.join)("|", productIds);
    (0,react.useEffect)(function() {
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.price.load(productIds, customer, {
            date: (0,get_future_date/* default */.Z)(useFutureEffectiveDate)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerHasChanged,
        productIdsHaveChanged,
        useFutureEffectiveDate
    ]);
    // Analytics
    (0,react.useEffect)(function() {
        if (!(0,fp.isEmpty)(prices)) {
            analytics/* default.ecommerceGA4 */.Z.ecommerceGA4(constants/* EVENTS.ECOMMERCE_GA4.VIEW_ITEM_LIST */.FP.ECOMMERCE_GA4.VIEW_ITEM_LIST, {
                customer: customer,
                prices: prices,
                products: comparerProducts
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        prices
    ]);
    var choosable60ProductIds = (0,fp.without)([
        src.PRODUCT.CHOOSABLE_50_TEETH
    ], ui.CHOOSABLE_PRODUCTS);
    var productsExcludingChoosable60 = (0,fp.reject)(function(product) {
        return (0,fp.includes)(product.id, choosable60ProductIds);
    }, comparerProducts);
    var onSelectBundleClick = (0,react.useCallback)(function() {
        drawer/* default.openDrawer */.Z.openDrawer(ui.DRAWER_IDS.PICKER)(dispatch);
    }, [
        dispatch
    ]);
    if (has_choosable_60_products(comparerProducts)) {
        var choosable60TeethEyes = (0,fp.find)({
            id: src.PRODUCT.CHOOSABLE_60_TEETH_EYES
        }, comparerProducts);
        // A choosable 60 product has been selected via the picker drawer
        if (choosableComparerProductId) {
            var customisedProduct = customise_selected_choosable_product((0,fp.find)({
                id: choosableComparerProductId
            }, comparerProducts), onSelectBundleClick);
            // Keep the product rank the same so the choosable product doesn't change it's position in the comparer
            var stableRank = choosable60TeethEyes === null || choosable60TeethEyes === void 0 ? void 0 : choosable60TeethEyes.rank;
            comparerProducts = (0,fp.concat)(productsExcludingChoosable60, (0,fp.set)("rank", stableRank, customisedProduct));
        } else {
            // Overwrite the relevant product properties to create the impression of a
            // base Choosable 60 product.
            var manufacturedBaseProduct = manufacture_base_choosable_product(choosable60TeethEyes, onSelectBundleClick);
            comparerProducts = (0,fp.concat)(productsExcludingChoosable60, manufacturedBaseProduct);
        }
    } else {
        comparerProducts = getProductsWithoutChoosable60(comparerProducts);
    }
    var expandoProducts = (0,ahm_ui/* populateExpandoServiceData */.Vk)(comparerProducts);
    var productPanelProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
        customer: customer,
        prices: prices
    }), {
        comparerProducts: expandoProducts,
        isCombiningHospitalWithExtras: isCombiningHospitalWithExtras,
        isPromo: true,
        isRankSorted: (0,fp.size)((0,fp.groupBy)("type", comparerProducts)) === 1,
        match: match,
        needsProductType: needsProductType,
        needsType: needsType,
        productIdsWithExcess: productIdsWithExcess,
        productType: needsProductType
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
        size: "extraExtraLarge",
        isFullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_head, {
                needsType: needsType,
                productType: needsProductType,
                needsProductType: needsProductType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (product_listing_styles_module_default()).productComparisonPaneWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "needs-type-".concat(needsType),
                    className: (product_listing_styles_module_default()).wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
                        variant: (product_listing_styles_module_default()).productCarouselSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* VisibilitySensor */.$V, {
                            payload: {
                                component: "ProductListingPage",
                                element: needsProductType
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_panels, (0,_object_spread/* default */.Z)({}, productPanelProps))
                        })
                    })
                })
            })
        ]
    });
};
ProductListingPageNeeds.defaultProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product_listing_common/* default.defaultProps */.Z.defaultProps), {
    isCombiningHospitalWithExtras: false,
    productIdsWithExcess: null
});
// @ts-expect-error - Automatic, Please fix when editing this file
var needs_mapStateToProps = function(state, props) {
    return {
        choosableComparerProductId: (0,select_choosable_comparer_product_id/* default */.Z)(state),
        customer: (0,select_customer/* default */.Z)(state),
        isCombiningHospitalWithExtras: select_is_combining_hospital_with_extras(state),
        needsProductType: (0,select_needs_product_type/* default */.Z)(state, props),
        needsType: (0,select_needs_type/* default */.Z)(state, props),
        prices: state.price.data,
        products: (0,select_filtered_needs_products_by_customer/* default */.Z)(state, props),
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
/* harmony default export */ var needs = ((0,redux/* compose */.qC)(needs_product_data_loader/* default */.Z, (0,es/* connect */.$j)(needs_mapStateToProps, product_listing_common/* default.mapDispatchToProps */.Z.mapDispatchToProps))(ProductListingPageNeeds));



/***/ }),

/***/ 2382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var _utils_get_filtered_products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5490);
/* harmony import */ var _utils_get_product_ids_from_needs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95890);
/* harmony import */ var _select_customer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34112);
/* harmony import */ var _select_needs_product_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82488);
/* harmony import */ var _select_needs_type__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69286);
/* harmony import */ var _select_products__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2664);







var selectFilteredNeedsProductsByCustomer = (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    _select_customer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    _select_needs_product_type__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    _select_needs_type__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    _select_products__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
], function(customer, needsProductType, needsType, products) {
    if (!(customer === null || customer === void 0 ? void 0 : customer.hospitalExcess)) {
        return null;
    }
    var productIdsFromNeeds = (0,_utils_get_product_ids_from_needs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        hospitalExcess: null,
        needsProductType: needsProductType,
        needsType: needsType
    });
    return (0,_utils_get_filtered_products__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        customer: customer,
        productIds: productIdsFromNeeds,
        products: products
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (selectFilteredNeedsProductsByCustomer);


/***/ }),

/***/ 51231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MediaDisplay; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        display: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var MediaDisplay = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-b1723609-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, media = param.media, up = param.up;
    var mediaQueries = theme.mediaQueries;
    var mediaQuery = up ? mediaQueries.below : mediaQueries.above;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), mediaQuery(theme.media[media]));
});


/***/ }),

/***/ 5490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);


// Fetches products based on id's and filters them based on scale and state
// @ts-expect-error - Automatic, Please fix when editing this file
var getFilteredProducts = function(param) {
    var customer = param.customer, productIds = param.productIds, products = param.products;
    // Get the products.
    var scale = customer.scale, state = customer.state;
    var resolvedProducts = _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getProducts */ .Z.getProducts(products, productIds);
    // Remove products based on customer state and scale.
    var filteredByStateAndScale = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(product) {
        return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isAvailableIn */ .Z.isAvailableIn(product, state) && _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isAvailableFor */ .Z.isAvailableFor(product, scale);
    }, resolvedProducts);
    // If we have no products left or we get an error, bail.
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(filteredByStateAndScale) || (products === null || products === void 0 ? void 0 : products.error)) {
        return null;
    }
    return filteredByStateAndScale;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFilteredProducts);


/***/ }),

/***/ 9347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);



// @ts-expect-error - Automatic, Please fix when editing this file
var defaultFormatter = function(productTypeString, needsString) {
    return "".concat(needsString, " ").concat(productTypeString);
};
// @ts-expect-error - Automatic, Please fix when editing this file
var productTypeFirstFormatter = function(productTypeString, needsString) {
    return "".concat(productTypeString, " ").concat(needsString);
};
var _obj;
var formatters = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS.EXTRAS_COVER, productTypeFirstFormatter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS.TAX, productTypeFirstFormatter), // @ts-expect-error - Automatic, Please fix when editing this file
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS.PREGNANCY_COVER, function(productTypeString, needsString) {
    return productTypeString === _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES[_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.NEEDS_PRODUCT_TYPE_SLUG.COMBINED] ? "".concat(needsString, " and birth") : defaultFormatter(productTypeString, needsString);
}), _obj);
// @ts-expect-error - Automatic, Please fix when editing this file
var getTitleFromType = function(param) {
    var needsProductType = param.needsProductType, needsType = param.needsType, productType = param.productType;
    if (needsProductType) {
        var ref;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly all: ""; readonly "bare-bones-cover": "bare-bones"; readonly "choosable-extras": "choosable extras"; readonly "extras-cover": "extras cover"; readonly "hospital-cover": "hospital cover"; ... 11 more ...; readonly package: "hospital and extras packages"; }'.
        var productTypeString = (ref = _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES === null || _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES === void 0 ? void 0 : _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES[needsProductType]) !== null && ref !== void 0 ? ref : "";
        var ref1;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly all: ""; readonly "bare-bones-cover": "bare-bones"; readonly "choosable-extras": "choosable extras"; readonly "extras-cover": "extras cover"; readonly "hospital-cover": "hospital cover"; ... 11 more ...; readonly package: "hospital and extras packages"; }'.
        var needsString = (ref1 = _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES === null || _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES === void 0 ? void 0 : _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES[needsType]) !== null && ref1 !== void 0 ? ref1 : "";
        var ref2;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ "extras-cover": (productTypeString: any, needsString: any) => string; tax: (productTypeString: any, needsString: any) => string; "pregnancy-cover": (productTypeString: any, needsString: any) => string; }'.
        var formatter = (ref2 = formatters === null || formatters === void 0 ? void 0 : formatters[needsType]) !== null && ref2 !== void 0 ? ref2 : defaultFormatter;
        var title = formatter(productTypeString, needsString);
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.trim)(title);
    }
    var ref3;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly all: ""; readonly "bare-bones-cover": "bare-bones"; readonly "choosable-extras": "choosable extras"; readonly "extras-cover": "extras cover"; readonly "hospital-cover": "hospital cover"; ... 11 more ...; readonly package: "hospital and extras packages"; }'.
    return (ref3 = _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES === null || _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES === void 0 ? void 0 : _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__.CUSTOMER_NEEDS_TITLES[productType]) !== null && ref3 !== void 0 ? ref3 : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (getTitleFromType);


/***/ }),

/***/ 85985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__BmU6a","productPage":"styles_productPage__f_vTM","body":"styles_body__CVtVX","button":"styles_button__db8T4","premiumChangePrompt":"styles_premiumChangePrompt__FXWFd","gridWrapper":"styles_gridWrapper__sAvX2","backButton":"styles_backButton__kGwhY","gridColumns":"styles_gridColumns__nZ9pY"};

/***/ }),

/***/ 83477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","offerTile":"styles_offerTile__CWVOx"};

/***/ }),

/***/ 83033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__Y6OET","productCarouselSection":"styles_productCarouselSection__o_EKs","extendedWidthContainer":"styles_extendedWidthContainer__UwfRI","heading":"styles_heading__JxeE_","productPanelRow":"styles_productPanelRow__qbJA3","overlayHospitalIncludes":"styles_overlayHospitalIncludes__AEXTn","overlayLabel":"styles_overlayLabel__NmKN_","overlayLabelIncludes":"styles_overlayLabelIncludes__Egrye","inclusionsCalloutWrapper":"styles_inclusionsCalloutWrapper__KgCHR","hospitalInclusions":"styles_hospitalInclusions__2MO1S","extrasInclusions":"styles_extrasInclusions__m4JXu","banner":"styles_banner__wAxIs","segmentationBar":"styles_segmentationBar__PYf0x","disclaimer":"styles_disclaimer__Lo8EM","overlayIncludesItemLabel":"styles_overlayIncludesItemLabel__JExi_","background":"styles_background__wP0qE","cheapestProductPromise":"styles_cheapestProductPromise__DYrPv","image":"styles_image__rMh9o","text":"styles_text__iDpsK","lastSection":"styles_lastSection__cGhJ1","productListingPaneWrapper":"styles_productListingPaneWrapper__vXIL8","productComparisonPaneWrapper":"styles_productComparisonPaneWrapper__pnebI","pregnancyDisclaimer":"styles_pregnancyDisclaimer__YajnD","fillWidth":"styles_fillWidth__bjMNf","wrapper":"styles_wrapper__sntqp","pregnancyHealthOptions":"styles_pregnancyHealthOptions__2OV_f","pregnancySection":"styles_pregnancySection__w_xPw","pregnancyOptionDescription":"styles_pregnancyOptionDescription__wgZkD"};

/***/ })

}]);